import axios from 'axios';
import {Location} from "../types/location";


export function getLocations(api: string) : Promise<Location[]> {
    return axios.get(api)
        .then((response) => response.data);
}

